// Foto de cada servicio en WebP de 800 px, por `url` del servicio. Los PNG de `imagen`
// en S3 pesan ~1 MB cada uno y quedan solo de respaldo.
import transformacion from './transformacion-digital.webp';
import marketing from './marketing-digital.webp';
import marca from './marca-y-diseno.webp';
import desarrollo from './desarrollo-web-y-aplicaciones.webp';
import awnaGo from './app-awnago.webp';
import cx from './customer-experience.webp';
import transformacionHero from './hero/transformacion-digital.webp';
import cxHero from './hero/customer-experience.webp';

const IMAGENES_SERVICIOS = {
    'transformacion-digital': transformacion,
    'marketing-digital': marketing,
    'marca-y-diseno': marca,
    'desarrollo-web-y-aplicaciones': desarrollo,
    'app-awnago': awnaGo,
    'customer-experience': cx,
};

// Fotos horizontales para el hero del detalle, que se abre a todo el ancho: son las
// originales de Shutterstock (1000 px, en el `carrousel` de cada servicio en S3).
// Los servicios que no están acá usan su foto cuadrada de 800 px.
export const FOTOS_HERO = {
    'transformacion-digital': transformacionHero,
    'customer-experience': cxHero,
};

export default IMAGENES_SERVICIOS;
